import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { CodeTable } from '../../core/model/v2/code-table';
import { Employer } from '../../core/models/employer/employer';
import { EmployerRegistration } from '../../core/models/employer/employer-registration';
import { EmployerRegistrationRequest } from '../../core/models/employer/employer-registration-request';
import { CommonService } from '../../core/services/v2/common.service';
import { EmployerService } from '../../core/services/v2/employer.service';
import { EmployerRegistrationComponent } from '../../employer/employer-registration/employer-registration.component';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';
import { Patient } from 'src/app/core/models/patient/patient';
import { EmployerAgencyProfileComponent } from 'src/app/employer/employer-agency-profile/employer-agency-profile.component';
import * as XLSX from 'xlsx';
import { AddNewMemberComponent } from '../add-new-member/add-new-member.component';
import { MemberService } from 'src/app/core/services/v2/shared-member-search.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { SearchPatientReq } from 'src/app/core/model/v2/practice/searchPatientList';
import { EmployeesComponent } from 'src/app/employer/employees/employees.component';
import { SharedService } from 'src/app/core/services/v2/shared-employees-data.service';
import { EmployerNamesService } from 'src/app/core/services/v2/shared-employer-names.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { PDFDialogComponent } from 'src/app/signup-organization/pdf-dialog/pdf-dialog.component';


@Component({
  selector: 'app-agencies',
  templateUrl: './agencies.component.html',
  styleUrls: ['./agencies.component.scss']
})
export class AgenciesComponent implements OnInit {
  employerControl = new FormControl();  // Make sure this is initialized here
  @ViewChild('fileInput',{static:false}) fileInput!: any;
  @ViewChild('pdfInput',{static:false}) pdfInput!: any;

  workbook: XLSX.WorkBook | null = null;
  pageSize = 10;
  page = 1;
  totalRecordsActive = 0;
  totalRecordsInactive = 0;
  dataLength;
  employersList: Employer[];
  employeeList: Patient[] = [];
    // Extract employer names
  isFirstConditionTrue: boolean = true; // Condition to switch between tables

  filteredEmployersList: Employer[];
  affilicationCtrl = new FormControl();
  filteredAffiliations: Observable<Employer[]>;
  selected = false;
  selectedEmployer: number;
  openSection: string;
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  showPatientProfile: boolean = false;
  employerId: number;
  file: File | null = null;
  pdfFile: File | null = null;
  isUploading: boolean = false;

  currentUserId: number;
  searchResult: any;
  displayedColumns: string[] = [
    "EmployerName",
    "ContactPerson",
    "Phone",
    "Address",
    "Website",
    "Actions"
  ];


  statesCodes: CodeTable;
  employerRegistration: EmployerRegistration;

  adminNameFormControl = new FormControl('');
  adminWebsiteFormControl = new FormControl('');
  employerNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  einNumberFormControl = new FormControl('', [
    Validators.required,
  ]);
  employerWebsiteFormControl = new FormControl('', [
    Validators.required,
  ]);
  empLine1FormControl = new FormControl('', [
    Validators.required,
  ]);
  empLine2FormControl = new FormControl('', [
    Validators.required,
  ]);
  empCityFormControl = new FormControl('', [
    Validators.required,
  ]);
  empStateFormControl = new FormControl('', [
    Validators.required,
  ]);
  empZipCodeFormControl = new FormControl('', [
    Validators.required,
  ]);
  empFirstNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  empLastNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  empTitleFormControl = new FormControl('', [
    Validators.required,Validators.maxLength(50),
  ]);
  empPhoneFormControl = new FormControl('', [
    Validators.required,
  ]);
  empEmailFormControl = new FormControl('', [
    Validators.required,
  ]);
  dataForm: FormGroup = new FormGroup({
    employerName: this.employerNameFormControl,
    einNumber: this.einNumberFormControl,
    employerWebsite: this.employerWebsiteFormControl,
    empLine1: this.empLine1FormControl,
   // empLine2: this.empLine2FormControl,
    empCity: this.empCityFormControl,
    empState: this.empStateFormControl,
    empZipCode: this.empZipCodeFormControl,
    adminName: this.adminNameFormControl,
    adminWebsite: this.adminWebsiteFormControl,
    empFirstName: this.empFirstNameFormControl,
    empLastName: this.empLastNameFormControl,
    empTitle: this.empTitleFormControl,
    empPhone: this.empPhoneFormControl,
    empEmail: this.empEmailFormControl,
  });
  selectedEmployerId: any;


  constructor(private employerService: EmployerService, private loaderService: WindowLoaderService,
    private dialog: MatDialog, private _snackBar: MatSnackBar,private employerNamesService: EmployerNamesService,
    private el: ElementRef, private commonService: CommonService,private memberService: MemberService,
    private sharedService: SharedService,    private datePipe: DatePipe, private router: Router,private _utils: UtilsService) {
    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((val) => {
        return this._filterAffilications(val || "");
      })
    );
  }

  ngOnInit() {
    this.commonService.GetItemsByCodeNamesWithoutCache(['STATE']).subscribe(
      codeTables => { this.statesCodes = codeTables.codeTable[0]; },
      error => console.log(error)
    );
    this.loadEmployers();
  }


  //  loadEmployers() {
  //   this.loaderService.show();
  //   this.employerService
  //     .GetAllActiveInActiveRegistrations(this.page, this.pageSize,2)
  //     .subscribe(
  //       (employers) => {
  //         console.log("employer list",employers)
  //         this.employersList = this.sortById(employers.pageItems);
  //          console.log("this.employerlist",this.employersList)
  //         this.totalRecordsActive = employers.totalRecords;
  //         this.dataLength = employers.totalRecords;
  //         if (this.dataLength < (this.pageSize - 1) * this.page)
  //           this.pageSize = 1;
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  //  }
  // loadEmployers() {
  //   this.loaderService.show(); // Show the loader before fetching the data
  //   this.employerService
  //     .GetAllActiveInActiveRegistrations(this.page, this.pageSize, 2)
  //     .subscribe(
  //       (employers) => {
  //         console.log("employer list", employers);

  //         // Process the employer data
  //         if (Array.isArray(employers.pageItems)) {
  //           this.employersList = this.sortById(employers.pageItems);
  //           console.log("this.employersList", this.employersList);

  //           // Send the sorted list to the shared service
  //           this.employerNamesService.setEmployers(this.employersList);
  //         } else {
  //           console.error("Invalid data structure: pageItems is not an array.");
  //         }

  //         // Pagination logic
  //         this.totalRecordsActive = employers.totalRecords;
  //         this.dataLength = employers.totalRecords;
  //         if (this.dataLength < (this.pageSize - 1) * this.page) {
  //           this.pageSize = 1;
  //         }
  //       },
  //       (error) => {
  //         console.error("Error fetching employer data", error);
  //         this.loaderService.hide();
  //       },
  //       () => {
  //         this.loaderService.hide(); // Hide the loader after fetching the data
  //       }
  //     );
  // }
  loadEmployers() {
    this.loaderService.show();
    this.employerService
      .GetAllActiveInActiveRegistrations(this.page, this.pageSize, 2)
      .subscribe(
        (employers) => {
          console.log("API Response:", employers);
          
          // Check if employers and pageItems exist and are valid
          if (employers && employers.pageItems) {
              this.employersList = this.sortById(employers.pageItems);
              console.log("Sorted Employer List:", this.employersList);
          } else {
              console.warn("No data received or malformed API response:", employers);
              this.employersList = [];  // Clear previous data if no valid response
          }

          // Check for totalRecords and set dataLength correctly
          if (employers && employers.totalRecords) {
              this.totalRecordsActive = employers.totalRecords;
              this.dataLength = employers.totalRecords;
          } else {
              this.totalRecordsActive = 0;
              this.dataLength = 0;
          }

          // Fix pagination logic without optional chaining
          if (this.dataLength <= (this.page - 1) * this.pageSize) {
              this.page = Math.max(1, Math.ceil(this.dataLength / this.pageSize));
          }
        },
        (error) => {
          console.error("API Error:", error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
}

  sortById(data: any) {
    return data.sort(function (a, b) {
      return -(a.id - b.id);
    });
  }

  openWebsiteLink(link: string) {
    let hyperLink = '';
    if (link.includes('http')) {
      hyperLink = link;
    } else {
      hyperLink = `https://${link}`;
    }
    window.open(hyperLink, '_blank');
  }

  handleOnClick(row?: any) {
    this.employerService.DeactiveEmployer(row.id).subscribe(
      (result) => {
        if (result && result.isSuccess) {
          this.loadEmployers();
        }
        return null;
      },
      (error) => {
        return error;
      }
    );
  }
  openEmpRegisterModal() {
      const dialogRef = this.dialog.open(EmployerRegistrationComponent);
      dialogRef.afterClosed().subscribe(
        (rest) => {
          console.log("Model closed");
          //this.form.controls["isAcceptedTermsConditions"].setValue(rest);
        },
        (error) => {
          console.error(error);
        }
      );
  }
  /* Employer Registration Section*/
  onSubmit(event: EmployerRegistration): void {
    const formObj = this.dataForm.getRawValue();
    const validate = this.validateForm(this.dataForm);
    if (!validate) {
      return;
    }
    this.saveRegistrationData(formObj);
    this.resetForm();
  }
  validateForm(addedForm: FormGroup) {
    const validationMessages = {
      'employerName': 'Employer Name is required.',
      'einNumber': 'EIN Number is required.',
      'employerWebsite': 'Employer Website is required.',
      'empLine1': 'Employer Address Line1 is required.',
      'empCity': 'Employer City Name is required.',
      'empState': 'Employer State is required.',
      'empZipCode': 'Employer ZipCode is required.',
      'adminName': 'Admin Name is required.',
      'adminWebsite': 'Admin Website Name is required.',
      'empFirstName': 'Employer First Name is required.',
      'empLastName': 'Employer Last Name is required.',
      'empTitle': 'Employer Title is required.',      
      'empPhone': 'Employer Phone is required.',
      'empEmail': 'Employer Email is required.',
    };
    const formControls = addedForm.controls;
    const invalidControls = [];
    for (const name in formControls) {
      if (formControls[name].invalid) {
        invalidControls.push(name);
      }
    }
    const value = this.empTitleFormControl.value;
    if((this.empTitleFormControl.errors && this.empTitleFormControl.errors.maxlength) || value && !/^[a-zA-Z\s]+$/.test(value)){
      this._snackBar.open( "Title must be a string with a maximum length of 5.", 'Ok', { duration: 5 * 1000 }); 
      return false;   
    }
    if (invalidControls.length > 0) {
      const controlName = invalidControls[0];
      this._snackBar.open(validationMessages[controlName], 'Ok', { duration: 5 * 1000 });
      const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + controlName + '"]');
      if (invalidControl.nodeName == 'APP-DYNAMIC-AUTOCOMPLETE') {
        invalidControl.childNodes[0].focus();
      }
      else {
        invalidControl.focus();
      }
      return false;
    }
    else {
      return true;
    }
  }
  saveRegistrationData(formObj: any) {
    if (!formObj) {
      this._snackBar.open('Data can not be saved.', 'Ok', { duration: 5 * 1000 });
    }
    let currentDate = new Date()
    let strCurrentDate = this.datePipe.transform(currentDate, "yyyy-MM-dd hh:mm:ss")
    const employerRegistrationData: EmployerRegistrationRequest = {
      id: formObj.id,
      adminName: formObj.adminName,
      adminWebsite: formObj.adminWebsite,
      employerName: formObj.employerName,
      einNumber: formObj.einNumber,
      employerWebsite: formObj.employerWebsite,
      employerLine: formObj.empLine1,
      employerLine2: formObj.empLine2,
      employerCity: formObj.empCity,
      employerState: formObj.empState,
      employerZipCode: formObj.empZipCode,
      employerFirstName: formObj.empFirstName,
      employerLastName: formObj.empLastName,
      employerTitle: formObj.empTitle,
      employerPhone: formObj.empPhone,
      employerEmail: formObj.empEmail,
      isActive: true,
      isApproved: true,
      approvedBy: 0,
      approvedOn: strCurrentDate,
      createdOn: strCurrentDate
    };
    this.loaderService.blockWithLoader(this.employerService.addEmployer(employerRegistrationData)).subscribe(
      (details) => {
        if (details.isSuccess) {
          document.getElementById("closeModel").click();
          //this.resetForm();
          this.loadEmployers();
        }
        else {
          this._snackBar.open('Duplicate EIN found.', 'Ok', { duration: 5 * 1000 });
        }
      },
      (error) => { console.error(error); }
    );
  }

  resetForm() {
    this.adminNameFormControl.setValue("");
    this.adminWebsiteFormControl.setValue("");
    this.employerNameFormControl.setValue("");
    this.einNumberFormControl.setValue("");
    this.employerWebsiteFormControl.setValue("");
    this.empLine1FormControl.setValue("");
    this.empLine2FormControl.setValue("");
    this.empCityFormControl.setValue("");
    this.empStateFormControl.setValue("");
    this.empZipCodeFormControl.setValue("");
    this.empFirstNameFormControl.setValue("");
    this.empLastNameFormControl.setValue("");
    this.empTitleFormControl.setValue("");
    this.empPhoneFormControl.setValue("");
    this.empEmailFormControl.setValue("");
  }
  closeNotification() {
    this.router.navigate(['/home']);
  }

  numberValidate(event: any) {
    const key = event.keyCode;
    return ((key >= 48 && key <= 57) // Allow number line
      // Allow number pad
    );
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  validateEmail(event: any) {
    const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (event.target.value != undefined || event.target.value != "") {
      const result: boolean = expression.test(event.target.value); // true
      if (!result) {
        event.target.value = "";
        this._snackBar.open('Invalid email.', 'Ok', { duration: 5 * 1000 });
      }
    }
  }
  _filterAffilications(value: string): Observable<any[]> {
    if (value.length >= 2) {
      return this.employerService.getEmployerDataByName(this.page, this.pageSize, value, 1).pipe(
        map((a) =>
          a.pageItems.filter((option) => {
            let fresult = option.employerName.toLowerCase().startsWith(value.toLowerCase()); option.employerName.toLowerCase().indexOf(value.toLowerCase()) === 0;
            return fresult;
          })
        )
      );
    }
    else if (value.length==0) {
      this.loadEmployers();
    }
  }

  optionEmployerSelected(employer: any) {
    this.loaderService.blockWithLoader(this.employerService.getEmployerDataByName(this.page, this.pageSize, employer.value, 1)).subscribe(
      (details) => {
        if (details) {
          this.employersList = this.sortById(details.pageItems);
          this.totalRecordsActive = details.totalRecords;
          this.dataLength = details.totalRecords;
          if (this.dataLength < (this.pageSize - 1) * this.page)
            this.pageSize = 1;
        }
        else {
          this.loadEmployers();
          this._snackBar.open('Employer not found.', 'Ok', { duration: 5 * 1000 });
        }
      },
      (error) => { console.error(error); }
    );
  }
  dropDownEmployerSelect(employer: any): void {
    // Handle the employer selection, e.g., fetch related data based on the employer's ID
    console.log('Selected Employer ID:', employer);
    this.loaderService.blockWithLoader(this.employerService.getEmployerDataByName(this.page, this.pageSize, employer.value, 1)).subscribe(
      (details) => {
        if (details) {
          this.employersList = this.sortById(details.pageItems);
          this.totalRecordsActive = details.totalRecords;
          this.dataLength = details.totalRecords;
          if (this.dataLength < (this.pageSize - 1) * this.page)
            this.pageSize = 1;
        }
        else {
          this.loadEmployers();
          this._snackBar.open('Employer not found.', 'Ok', { duration: 5 * 1000 });
        }
      },
      (error) => { console.error(error); }
    );
  }
  // dropDownEmployerSelect(event: any): void {
  //   const selectedEmployer = event.value;  // This will be the full employer object
  //   console.log('Selected Employer:', selectedEmployer);  // Log the selected employer
  //   this.dropdownMethod(selectedEmployer);
  // }

  handleEmployerChange(employer: any): void {
    this.isFirstConditionTrue = !this.isFirstConditionTrue;

    // Extract necessary data from the employer object
    const currentUserId = employer.id;  // Assuming employer has a userId property
    const searchCriteria = employer.criteria;  // Assuming employer has a criteria property
  
    // Log the extracted values
    console.log('Extracted currentUserId:', currentUserId);
    console.log('Extracted searchCriteria:', searchCriteria);
  
    // Pass dynamic parameters to searchPatient
    this.sharedService.searchPatient(currentUserId, 1, 10, searchCriteria).subscribe(
      (res) => {
        console.log('Search Results:', res);  // Log the search results
        this.employeeList = res.patients;
        console.log('employee List Results:',  this.employeeList);  // Log the search results

      },
      (error) => {
        console.error('Search Error:', error);  // Log any errors
      }
    );
  }
  
  changeIndex(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.page = event.pageSize + 1;
    this.loadEmployers();
    // this.searchPatient();

  }

  togglePatientSidebar(employerId: number): void {
    console.log("Selected employer ID:", employerId);
    this.selectedEmployer = employerId; // Assign only the ID
    console.log("this.selectedEmployer:", this.selectedEmployer);
  
    // Open the employer dialog and pass the selectedEmployer (ID)
    this.openEmployerDialog(this.selectedEmployer);
  
    // Toggle the sidebar states
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }
  
  openEmployerDialog(employerId: number): void {
    this.dialog.open(EmployerAgencyProfileComponent, {
      width: '80%', // Set dialog width
      data: employerId, // Pass only the ID as data
    });
  }
  
// Handle file selection and initiate download
// onFileChangeAndDownload(event: Event): void {
//   const input = event.target as HTMLInputElement;

//   if (input && input.files && input.files.length > 0) {
//     const file = input.files[0];
//     const reader = new FileReader();

//     reader.onload = function (e: ProgressEvent) {
//       const target = e.target as FileReader;
//       const result = target && target.result;
//       if (result) {
//         const data = new Uint8Array(result as ArrayBuffer);
//         const workbook = XLSX.read(data, { type: 'array' });
    
//         // Example modification
//         const newSheet = XLSX.utils.aoa_to_sheet([['Sample', 'Data', 'Modified']]);
//         XLSX.utils.book_append_sheet(workbook, newSheet, 'Modified Sheet');
    
//         // Trigger download
//         const fileName = 'Modified_File.xlsx';
//         XLSX.writeFile(workbook, fileName);
//       }
//     };

//     reader.readAsArrayBuffer(file);
//   }
// }
// downloadCensusTemplate(): void {
//   const link = document.createElement('a');
//   link.href = 'Downloads/CensusTemplate.xlsx'; // Adjust path based on your file location
//   link.download = 'CensusTemplate.xlsx';
//   link.click();
// }
// downloadCensusTemplate(): void {
//   const fileName = 'CensusTemplate.xlsx';
//   const fileUrl = 'c:/Users/AbdulhakeemMohammad/Downloads/CensusTemplate.xlsx'; // Replace with the actual path or URL of the file

//   // Create an invisible link element
//   const anchor = document.createElement('a');
//   anchor.href = fileUrl;
//   anchor.download = fileName;

//   // Append the link to the body
//   document.body.appendChild(anchor);

//   // Trigger the download
//   anchor.click();

//   // Remove the link element after the download is triggered
//   document.body.removeChild(anchor);
// }
// downloadFile() {
//   const fileUrl = 'src/assets/pdf/CensusTemplate.xlsx'; // Replace with your file URL
//   const link = document.createElement('a');
//   link.href = fileUrl;
//   link.download = fileUrl;
//   // link.download = 'CensusTemplate.xlsx'; // Name of the file to be downloaded
//   link.click();
// }
downloadFile() {
  const fileUrl = 'assets/pdf/CensusTemplate.xlsx'; // Correct path to your assets folder
  const anchor = document.createElement('a');
  anchor.href = fileUrl;
  anchor.download = 'CensusTemplate.xlsx'; // The file name for download
  anchor.click();
  anchor.remove(); // Clean up the created element

}

openInstructionFile() {
  const pdfUrl = 'assets/pdf/EMPLOYER_CENSUS_TEMPLATE_INSTRUCTIONS.pdf';
  const windowFeatures = 'width=800,height=600,scrollbars=yes,resizable=yes';
  window.open(pdfUrl, 'PDFWindow', windowFeatures);
}
openPdfDialog() {
  let data = {
    title: 'Employer Template Instructions',
    filename: 'New Employer Onboarding.pdf',
  }


  this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
}


  openAddNewMemberDialog(id) {
    const newMemberDialog = this.dialog.open(AddNewMemberComponent, {
      width: "52%",
      data: { isFromAdmin: true,title: "Employee",id:id}
    });
    newMemberDialog.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Dialog result:', result);
        this.memberService.refreshMembers(); // Notify MembersSearchComponent
      }
    });
  }
   // Handle file selection
//    onFileChange(event: Event): void {
//     const input = event.target as HTMLInputElement;
  
//     if (input && input.files && input.files.length > 0) {
//       this.file = input.files[0]; // Store the selected file
//       this.uploadFile();  // Automatically trigger file upload when file is selected
 
//     }
//   }
//   // Upload the file to the API
//  uploadFile(): void {
//    if (!this.file) {
//      alert('Please select a file first');
//      return;
//    }
//   console.log(this.file)
//   this.isUploading = true; // Set uploading flag to true
 
//    // Create a FormData object to send the file
//    const formData = new FormData();
//    formData.append('employeeDataSource', this.file);
//    console.log(formData)
//    // Debug: Log FormData content
//    // formData.forEach((value, key) => {
//    //   console.log(`${key}:`, value);
//    // });
//    // Call the API with FormData
 
//    this.employerService.bulkUploadEmployeeData(formData).subscribe(
//      (res) => {
//        console.log('Upload successful:', res);
//          // Assign the response array directly to the dataSource
//          // this.searchData = res;
//         //  this.employersList = res;
 
//          // Optionally configure displayedColumns if needed
//          this.displayedColumns = [ "EmployerName",
//           "Name",
//           "Phone",
//           "Address",
//           "Website",
//           "Actions"];
//        this.isUploading = false;  // Set uploading flag to false after success
//      },
//      (error) => {
//        console.error('Upload error:', error);
//        this.isUploading = false;  // Set uploading flag to false on error
//      }
//    );
//  }
// onFileChange(event: Event, employerId: number): void {
//   const input = event.target as HTMLInputElement;

//   if (input && input.files && input.files.length > 0) {
//     this.file = input.files[0]; // Store the selected file
//     this.uploadFile(employerId); // Automatically trigger file upload when file is selected
//   }
// }

// uploadFile(employerId: number): void {
//   if (!this.file) {
//     alert('Please select a file first');
//     return;
//   }

//   console.log('Selected file:', this.file);
//   this.isUploading = true; // Set uploading flag to true

//   // Create a FormData object to send the file and employerId
//   const formData = new FormData();
//   formData.append('employeeDataSource', this.file);
//   // formData.append('employerId', employerId.toString()); // Append employerId to FormData

//   console.log('FormData before upload:', formData);

//   // Call the API with FormData
//   this.employerService.bulkUploadEmployeeData(formData, employerId).subscribe(
//     (res) => {
//       console.log('Upload successful:', res);
//       // this.searchData = res; // Assign the response array directly to the dataSource
//       this.employersList = res;
//       this.displayedColumns = ['patientName', 'contact']; // Optionally configure displayedColumns
//       this.isUploading = false; // Set uploading flag to false after success
//     },
//     (error) => {
//       console.error('Upload error:', error);
//       this.isUploading = false; // Set uploading flag to false on error
//     }
//   );
// }
handleFileClick(employer: any){
  if(this.fileInput && this.fileInput.nativeElement && this.fileInput.nativeElement.value)
  this.fileInput.nativeElement.value = '';
if(this.file)
  this.file = null;
  this.fileInput.nativeElement.click();
  this.selectedEmployerId = employer.id;
}
onFileChange(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input && input.files && input.files.length > 0) {
    this.file = input.files[0]; // Store the selected file
    this.uploadFile(); // Pass employerId to uploadFile
    input.files = null;
  } else {
    this._utils.showMessageSnackBar('Please select a file first',true);
  }
}

uploadFile(): void {
  if (!this.file) {
    this._utils.showMessageSnackBar('Please select a file first',true);
    return;
  }
  this.isUploading = true; // Set uploading flag
  // Prepare FormData for API call
  const formData = new FormData();
  formData.append('employeeDataSource', this.file);
  formData.append('employerId', this.selectedEmployerId.toString()); // Include employerId in FormData
  this.loaderService.show();
  // Call the API
  this.employerService.bulkUploadEmployeeData(formData).subscribe(
    (res) => {
      // this.employersList = res; // Update the employers list
      this.isUploading = false; // Reset uploading flag
       this.loaderService.hide();
      this._utils.showMessageSnackBar(JSON.stringify(res)); 
      this.selectedEmployerId = null;
    },
    (error) => {
      this.loaderService.hide();
      this._utils.showMessageSnackBar(error.error,true);
      this.isUploading = false; // Reset uploading flag
      this.selectedEmployerId = null;
    },
    
  );
}
onEmployerSelect(employerId: number): void {
  if (employerId) {
    this.filteredEmployersList = this.employersList.filter(employer => employer.id === employerId);
  } else {
    this.filteredEmployersList = this.employersList;  // Show all employers if none selected
  }
}
nagigateToViewEmployees(employer: any): void{
  console.log("employer",employer);
  // this.router.navigate(['/agency/employee-list',employer.id]);
  this.router.navigate(['/agency/employee-list'], {       state: { data: { id: employer.id } },  });
 
}
handlePDFClick(employer: any){
  if(this.pdfInput && this.pdfInput.nativeElement && this.pdfInput.nativeElement.value)
  this.pdfInput.nativeElement.value = '';
if(this.pdfFile)
  this.pdfFile = null;
  this.pdfInput.nativeElement.click();
  this.selectedEmployerId = employer.id;
}
onPDFChange(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input && input.files && input.files.length > 0) {
    this.pdfFile = input.files[0]; // Store the selected file
    this.uploadPDF();
    // Pass employerId to uploadFile
    input.files = null;
  } else {
    this._utils.showMessageSnackBar('Please select a PDF file first', true);
  }
}

uploadPDF(): void {
  if (!this.pdfFile) {
    this._utils.showMessageSnackBar('Please select a PDF file first', true);
    return;
  }
  this.isUploading = true; // Set uploading flag
  // Prepare FormData for API call
  const formData = new FormData();
  formData.append('employerFile', this.pdfFile);
  console.log('File name:', this.pdfFile.name);
  formData.append('employerId', this.selectedEmployerId.toString()); // Include employerId in FormData
  this.loaderService.show();
  // Call the API
  this.employerService.pdfEmployerFileUploadData(formData).subscribe(
    (res) => {
      // this.employersList = res; // Update the employers list
      this.isUploading = false; // Reset uploading flag
       this.loaderService.hide();
      // this._utils.showMessageSnackBar(JSON.stringify(res)); 
      this.selectedEmployerId = null;
    },
    (error) => {
      this.loaderService.hide();
      this._utils.showMessageSnackBar(error.error,true);
      this.isUploading = false; // Reset uploading flag
      this.selectedEmployerId = null;
    },
    
  );
}
}
